import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import customConfirmationBFV from "../../../../src/content/bibles-for-vietnam/customConfirmation";
import "../../../../src/content/bibles-for-vietnam/bible-for-vietnam.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationBFV,
  React
};